/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BattleAdminListItemDto = {
  /**
   * 배틀 ID
   */
  id: string;
  /**
   * 배틀명
   */
  battleName: string;
  /**
   * 대상 퀴즈팩 제목
   */
  quizPackTitle: string | null;
  /**
   * 대상 퀴즈팩 썸네일 (배틀 자체 이미지는 없음)
   */
  quizPackThumbnailUrl: string | null;
  /**
   * 생성자 유저 ID
   */
  creatorUserId: number;
  /**
   * 생성자 닉네임
   */
  creatorNickname: string | null;
  /**
   * 배틀 상태
   */
  status: BattleAdminListItemDto.status;
  /**
   * 참여자 수
   */
  participantCount: number;
  /**
   * 완주자 수
   */
  completerCount: number;
  /**
   * 시작 시각
   */
  startedAt: string;
  /**
   * 마감 시각
   */
  deadline: string;
  /**
   * 생성 시각
   */
  createdAt: string;
  /**
   * 정산된 총 상금 (null = 미정산)
   */
  prizePoolTotal: number | null;
  /**
   * 정산 완료 시각 (null = 미정산)
   */
  settledAt: string | null;
};
export namespace BattleAdminListItemDto {
  /**
   * 배틀 상태
   */
  export enum status {
    ACTIVE = "ACTIVE",
    ENDED = "ENDED",
  }
}
